import { combineReducers, configureStore } from "@reduxjs/toolkit";

import ui from "./slices/ui";
import workspace from "./slices/workspace";
import permission from "./slices/permission";
import role from "./slices/role";
import user from "./slices/user";
import customer from "./slices/customer";
import license from "./slices/license";
import invoice from "./slices/invoice";
import receipt from "./slices/receipt";
import documentHeader from "./slices/documentHeader";
import payment from "./slices/payment";
import paymentMethod from "./slices/paymentMethod";
import sequence from "./slices/sequence";
import taxCode from "./slices/taxCode";
import product from "./slices/product";
import unallocatedPayment from "./slices/unallocatedPayment";
import reminderLog from "./slices/reminderLog";
import fiscal from "./slices/fiscal";
import settings from "./slices/settings";
import checkout from "./slices/checkout";

const reducer = combineReducers({
  ui,
  workspace,
  permission,
  role,
  user,
  customer,
  license,
  invoice,
  receipt,
  documentHeader,
  payment,
  paymentMethod,
  sequence,
  taxCode,
  product,
  unallocatedPayment,
  reminderLog,
  fiscal,
  settings,
  checkout,
});

export const store = configureStore({ reducer });

export default store;
